import React from 'react';

const ProcessSection = () => {
    const imageCardClass =
        "rounded-md sm:rounded-lg overflow-hidden shadow-md sm:shadow-lg w-full max-w-[150px] sm:max-w-[190px] md:max-w-[220px] mx-auto";

    return (
        <section className="py-20 px-6 bg-[#FFFFFF]">
            <div className="max-w-screen-xl mx-auto">
                <div className="text-center mb-12">
                    <p className="text-sm uppercase tracking-[0.3em] text-[#E85D44] mb-4">
                        OUR PROCESS
                    </p>
                    <h2 className="text-4xl md:text-5xl font-serif text-gray-900">
                        How Yours Is Made (A-to-Z)
                    </h2>
                </div>

                {/* Process Flow with Arrows */}
                <div className="flex flex-col lg:flex-row items-center justify-center gap-4">
                    {/* Step 1 */}
                    <div className="bg-white rounded-xl shadow-lg p-4 flex-1 max-w-xs hover:shadow-xl transition-shadow">
                        <div className="mb-3">
                            <img src="/images/modeling-cad.jpg" alt="Modeling" className="w-full h-32 object-cover rounded-lg" loading="lazy" />
                        </div>
                        <div className="flex items-center gap-2 mb-2">
                            <span className="w-8 h-8 bg-[#E85D44] text-white rounded-full flex items-center justify-center font-bold text-sm">1</span>
                            <h3 className="text-base font-bold text-gray-900">Prep & Model</h3>
                        </div>
                        <p className="text-xs text-gray-600">Design using builder tool</p>
                    </div>

                    {/* Arrow */}
                    <div className="text-[#E85D44] hidden lg:block">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                    </div>
                    <div className="text-[#E85D44] lg:hidden">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>

                    {/* Step 2 */}
                    <div className="bg-white rounded-xl shadow-lg p-4 flex-1 max-w-xs hover:shadow-xl transition-shadow">
                        <div className="mb-3">
                            <img src="/images/printer-in-action.jpg" alt="Printing" className="w-full h-32 object-cover rounded-lg" loading="lazy" />
                        </div>
                        <div className="flex items-center gap-2 mb-2">
                            <span className="w-8 h-8 bg-[#E85D44] text-white rounded-full flex items-center justify-center font-bold text-sm">2</span>
                            <h3 className="text-base font-bold text-gray-900">3D Print</h3>
                        </div>
                        <p className="text-xs text-gray-600">PLA+ printed (~9 hours)</p>
                    </div>

                    {/* Arrow */}
                    <div className="text-[#E85D44] hidden lg:block">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                    </div>
                    <div className="text-[#E85D44] lg:hidden">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>

                    {/* Step 3 */}
                    <div className="bg-white rounded-xl shadow-lg p-4 flex-1 max-w-xs hover:shadow-xl transition-shadow">
                        <div className="mb-3">
                            <img src="/images/finishing.jpg" alt="Finishing" className="w-full h-32 object-cover rounded-lg" loading="lazy" />
                        </div>
                        <div className="flex items-center gap-2 mb-2">
                            <span className="w-8 h-8 bg-[#E85D44] text-white rounded-full flex items-center justify-center font-bold text-sm">3</span>
                            <h3 className="text-base font-bold text-gray-900">Hand Finish</h3>
                        </div>
                        <p className="text-xs text-gray-600">Trim & smooth edges</p>
                    </div>

                    {/* Arrow */}
                    <div className="text-[#E85D44] hidden lg:block">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                    </div>
                    <div className="text-[#E85D44] lg:hidden">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>

                    {/* Step 4 */}
                    <div className="bg-white rounded-xl shadow-lg p-4 flex-1 max-w-xs hover:shadow-xl transition-shadow">
                        <div className="mb-3">
                            <img src="/images/battery-bay-logo.jpg" alt="Electronics" className="w-full h-32 object-cover rounded-lg" loading="lazy" />
                        </div>
                        <div className="flex items-center gap-2 mb-2">
                            <span className="w-8 h-8 bg-[#E85D44] text-white rounded-full flex items-center justify-center font-bold text-sm">4</span>
                            <h3 className="text-base font-bold text-gray-900">Electronics</h3>
                        </div>
                        <p className="text-xs text-gray-600">LED & battery install</p>
                    </div>

                    {/* Arrow */}
                    <div className="text-[#E85D44] hidden lg:block">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                    </div>
                    <div className="text-[#E85D44] lg:hidden">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>

                    {/* Step 5 */}
                    <div className="bg-white rounded-xl shadow-lg p-4 flex-1 max-w-xs hover:shadow-xl transition-shadow">
                        <div className="mb-3">
                            <img src="/images/qc-on-off.jpg" alt="Quality Check" className="w-full h-32 object-cover rounded-lg" loading="lazy" />
                        </div>
                        <div className="flex items-center gap-2 mb-2">
                            <span className="w-8 h-8 bg-[#E85D44] text-white rounded-full flex items-center justify-center font-bold text-sm">5</span>
                            <h3 className="text-base font-bold text-gray-900">Quality Check</h3>
                        </div>
                        <p className="text-xs text-gray-600">ON/OFF test & packaging</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessSection;
